export const MAX_PDP_WIDTH = 1200;
export const ZOOM_AREA_WIDTH = 369;
export const SDL_FOOTER_SEEMAIL = 'sdl-footer-seemail';
export const QUANTITY_SELECTOR = {
  MIN_VALUE: 1,
  MAX_VALUE: 9999,
  MAX_LENGTH: 4,
  ALLOWED_PATTERN: '[0-9]*',
  INCREASE_ICON: '+',
  DECREASE_ICON: '-',
  ALLOWED_KEYS: ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'],
};
